// ============================================================
// ANSICHTSSACHE-AGENT – Die Fläche eines Ladezustands
// ============================================================

import { cn } from "@/lib/utils";

/**
 * Die graue Flaeche eines Ladezustands.
 *
 * Sie steht auf `bg-tertiary` und nicht auf `bg-secondary`:
 * `bg-secondary` IST der Grund der Seite (#f6f4f2), und ein
 * Platzhalter in der Farbe des Grundes ist keiner — auf jeder
 * Flaeche ausserhalb einer weissen Karte (Seitenkopf, Tafel) war
 * er schlicht unsichtbar.
 */
function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("animate-skeleton bg-bg-tertiary rounded", className)} {...props} />;
}

export { Skeleton };
